(function() {
    'use strict';

    angular.module('aprima-provider-api').factory('PdpmpRepository', [
        '$q',
        'PdpmpRepositoryTs',
        PdpmpRepository
    ]);

    function PdpmpRepository(
        $q,
        PdpmpRepositoryTs
    ) {
        return {
            createReport: createReport,
            getConfiguration: getConfiguration,
        };

        function createReport(serviceSiteId, patientId, providerId, visitId, messageId) {
            var promise = PdpmpRepositoryTs.createReport(serviceSiteId, patientId, providerId, visitId, messageId).toPromise();
            return $q.when(promise);
        }

        function getConfiguration() {
            var promise = PdpmpRepositoryTs.getConfiguration().toPromise();
            return $q.when(promise);
        }
    }
})();